/*
 * File: input.ts
 * File Created: 2023-12-26 02:06:46
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:41:15
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import InputDate from "../input-date/input-date";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect/index.js";
import "flatpickr/dist/plugins/monthSelect/style.css";

@Component
export default class InputMonth extends InputDate {
    get config() {
        return {
            allowInput: true,
            dateFormat: "Y/m",
            enableTime: false,
            mode:
                this.multiple === true
                    ? "multiple"
                    : this.multiple === "range"
                      ? "range"
                      : "single",
            plugins: [
                new (monthSelectPlugin as any)({
                    shorthand: true,
                    dateFormat: "Y/m",
                }),
            ],
        };
    }
}
